import React from 'react';
import WarningIcon from '@material-ui/icons/Warning';
import CloseIcon from '@material-ui/icons/Close';
import Snackbar from '@material-ui/core/Snackbar';
import { alertStyles } from '../../constants/theme/styles/components/alerts';
import { snackbarStyles } from '../../constants/theme/styles/components/snackbar';



interface ToastProps {
    message: string | JSX.Element;
    hide: boolean;
    onClose: () => any;
}
export function Toast(props: ToastProps) {
    const { message, hide, onClose } = props;
    const alertClasses = alertStyles();
    const snackbarClasses = snackbarStyles();

    if (!message || hide) return null;

    const renderMessage = () => {
        if (typeof message === 'string') {
            return (
                <p>{message}</p>
            );
        }

        return message;
    };

    return (
        <>
            <Snackbar className={snackbarClasses.snackbarContainer} open >
                <div className={`${alertClasses.alertContainer} warning-alert`}>
                    <WarningIcon className='alert-icon' />
                    <div className='alert-content'>
                        {renderMessage()}
                    </div>
                    <button className='un-button alert-close-button' type='button' onClick={onClose}><CloseIcon /><span className='visually-hidden'>Close Button</span></button>
                </div>
            </Snackbar>
        </>
    );

}